<template>
  <span
    class="badge"
    :class="[`bg-${bg}`]">
    <slot>
      {{ label }}
    </slot>
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      requred: true,
    },
  },
  computed: {
    bg() {
      switch (this.status) {
        case 'active':
        case 'completed':
        case 'closed':
          return 'primary';
        case 'assigned':
          return 'info';
        case 'contractor_invited':
        case 'in_work':
          return 'warning';
        case 'cancelled':
        case 'dispute':
          return 'danger';
        case 'draft':
          return 'gray-600';
        default:
          return '';
      }
    },
    label() {
      switch (this.status) {
        case 'active':
          return 'Активный';
        case 'completed':
          return 'Выполнен';
        case 'closed':
          return 'Завершен';
        case 'assigned':
          return 'Назначен';
        case 'in_work':
          return 'В работе';
        case 'cancelled':
          return 'Отменен';
        case 'dispute':
          return 'Спор';
        case 'draft':
          return 'Новый';
        case 'contractor_invited':
          return 'Повторный';
        default:
          return '';
      }
    },
  },
};
</script>
